// extracted by mini-css-extract-plugin
module.exports = {"form-button":"style_form-button__2nf3P","background-button":"style_background-button__16sxb","icon-wrapper":"style_icon-wrapper__1LBb1"};